import { useEffect, useRef, useState } from "react"
import Footer from "../../components/Footer"
import Select from 'react-select';
import { ConfigurationService } from "../../services/ConfigurationService";
import { useSession } from "../../hooks/useSession";
import { LocalStorageService } from "../../services/LocalStorageService";
import { PROFILES, STORAGE } from "../../constants";
import { useLocation, useNavigate } from "react-router-dom";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import { AlertService } from "../../services/Alert";
import { useTranslation } from 'react-i18next';
import { UsersService } from "../../services/UsersService";
declare const bootstrap: any;

function SelectAccountPage() {
    const { t } = useTranslation();

    const { state  } = useLocation()
    const navigate = useNavigate();
    
    const { session } = useSession();
    const { account } = useCurrentAccount();
    
    const modalRef = useRef<HTMLDivElement>(null)
    const [modal, setModal] = useState<any>(null)
    const [accounts, setAccounts] = useState([])
    
    const [accountSelected, setAccountSelected] = useState(account ? { value: account.id, label: account.nombre }: null)

    const redirect = () => {
        modal.hide()
        navigate(state && state.redirectTo ? state.redirectTo: '/')
    }

    const goBack = () => {
        modal.hide()
        navigate(-1)
    }

    const save = async() => {
        const account = accounts.find( a => +a.account_id === +accountSelected.value)
        LocalStorageService.save(STORAGE.ACCOUNT_SELECTED, {...account, id: account.account_id });
        
        await handlePermissions(session.id, account.account_id, session.profile)

        redirect()

        AlertService.toastSuccess('La selección de cuenta se realizó correctamente.', 4000)
    }

    const getAll = async() => {
        try {
            const allData = {
                user_id: session.id
            }
            const { data } = await ConfigurationService.getAllAccounts(allData);
            setAccounts(data);

        } catch (error) {
            console.log(error);
        }
    }

    const handlePermissions = async(user_id: number, account_id: number, profile: string) => {

        if(profile.toLowerCase() === PROFILES.ROOT || profile.toLowerCase() === PROFILES.ADMIN) {
            return LocalStorageService.save(STORAGE.PERMISSIONS, { 
                full_access: true
            });
        }
        
        if(profile.toLowerCase() === PROFILES.SUPERVISOR ) {

            const { data } = await UsersService.getCurrentPermissions({
                account_id,
                user_id
            })
            return LocalStorageService.save(STORAGE.PERMISSIONS, data);
        }

    }
    
    useEffect(() => {
        if (modalRef.current) {
            const modalInstance = new bootstrap.Modal(modalRef.current, {})
            modalInstance.show()
            setModal(modalInstance)
        }
    }, [modalRef])


    useEffect(() => {
        if(!state?.accounts) {
            getAll();
        } else {
            setAccounts(state.accounts);
        }
        
    }, [state?.accounts])

    return (
        <>
            <header id="header" className="navbar navbar-expand-lg navbar-fixed navbar-container navbar-bordered bg-white">
                <div className="navbar-nav-wrap">

                    <a className="navbar-brand" href="../index.html" aria-label="Front">
                        <img className="navbar-brand-logo" src="/assets/img/logo.png" alt="Logo" data-hs-theme-appearance="default" />
                        <img className="navbar-brand-logo-mini" src="/assets/svg/logos/logo-short.svg" alt="Logo" data-hs-theme-appearance="default" />
                    </a>
                    <div className="navbar-nav-wrap-content-start">

                        <button type="button" className="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler">
                            <i className="bi-arrow-bar-left navbar-toggler-short-align" data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' data-bs-toggle="tooltip" data-bs-placement="right" title="Collapse"></i>
                            <i className="bi-arrow-bar-right navbar-toggler-full-align" data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' data-bs-toggle="tooltip" data-bs-placement="right" title="Expand"></i>
                        </button>

                    </div>


                    <div className="navbar-nav-wrap-content-end">

                        <ul className="navbar-nav">
                            <li className="nav-item" style={{ width: '100px' }} >
                                <img src="/assets/skeleton/nav-title.png" className="img-fluid " style={{ height: '16px' }} />
                            </li>
                            <li className="nav-item" style={{ width: '100px' }} >
                                <img src="/assets/skeleton/nav-title.png" className="img-fluid " style={{ height: '16px' }} />
                            </li>

                            <li className="nav-item">

                                <div className="dropdown">
                                    <a className="navbar-dropdown-account-wrapper" href="#" id="accountNavbarDropdown" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" data-bs-dropdown-animation>
                                        <span className="avatar avatar-sm avatar-primary avatar-circle">
                                            <img className="avatar-img" src="assets/skeleton/image-2.png" />
                                        </span>
                                    </a>
                                </div>

                            </li>
                        </ul>

                    </div>

                </div>
            </header>

            <aside className="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered  navbar-voices " >
                <div className="navbar-vertical-container">
                    <div className="navbar-vertical-footer-offset">

                        <div className="navbar-brand" style={{ paddingLeft: '20px' }}>
                            <img src="/assets/skeleton/image.png" className="img-fluid " />
                        </div>


                        <div className="navbar-vertical-content">
                            <div id="navbarVerticalMenu" className="nav nav-pills nav-vertical card-navbar-nav">

                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-title.png" className="img-fluid " style={{ width: '50%', height: '16px' }} />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>

                                <div className="nav-item py-2 pt-5">
                                    <img src="/assets/skeleton/nav-title.png" className="img-fluid " style={{ width: '50%', height: '16px' }} />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>
                                <div className="nav-item py-2">
                                    <img src="/assets/skeleton/nav-item.png" className="img-fluid" />
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </aside>

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <img src="/assets/skeleton/breadcrumb.png" className="img-fluid" />
                                </nav>
                                <img src="/assets/skeleton/main-title.png" className="img-fluid" />
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-md-center">
                        <div className="col-10 ">
                            <img src="/assets/skeleton/table.svg" className="img-fluid w-100" data-hs-theme-appearance="default"/>
                            <img src="/assets/skeleton/table-dark.svg" className="img-fluid w-100" data-hs-theme-appearance="dark"/>
                        </div>
                    </div>

                </div>
                <Footer />
            </main>

            <div className="modal fade" ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" >
                <div className="modal-dialog modal-dialog-centered" role="document">

                    <div className="modal-content">
                        {/* <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalCenterTitle">Modal title</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div> */}
                        <div className="modal-body text-center">
                            <img src="/assets/svg/illustrations/oc-project-development.svg" className="img-fluid w-50" />
                            <h2 className="mt-5">{t("accounts.selection.label-selection")}</h2>
                            <p className="mb-5">{t("accounts.selection.text-selection")}</p>

                            <div className="text-start">
                                <Select
                                    options={accounts.map( d => ({ value: d.account_id, label: d.nombre }))}
                                    isMulti={false}
                                    className={'form-select-custom ' + (false ? ' is-invalid' : '')}
                                    classNamePrefix='form-select-custom'
                                    placeholder={t("accounts.selection.placeholder-select")}
                                    onChange={ (data: any) => setAccountSelected(data) }
                                    value={accountSelected}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            { account && <button type="button" className="btn btn-white" onClick={goBack}>Cancelar</button>}
                            <button type="button" className="btn btn-primary" onClick={save} disabled={!accountSelected}>{t("accounts.selection.label-btn")}</button>
                        </div>
                    </div>


                </div>
            </div>
        </>
    )
}
export default SelectAccountPage